
// // Toggle on click
// document.addEventListener("click", function (e) {
//   if (!e.target.matches(".size-units-js input")) return;

//   const wrapper = e.target.closest(".size-chart-modal-wrapper");
//   if (!wrapper) return;

//   wrapper.querySelectorAll(".units-table").forEach(table => {
//     table.classList.remove("active");
//   });

//   wrapper.querySelector(e.target.dataset.class)?.classList.add("active");
// });


// // Reset to Inches whenever modal opens
// function resetSizeChartUnits(container = document) {
//   container.querySelectorAll(".size-chart-modal-wrapper").forEach(wrapper => {

//     // Select Inches radio
//     const inchesRadio = wrapper.querySelector(
//       '.size-units-js input[data-class=".size-inches-unit-js"]'
//     );

//     if (inchesRadio) {
//       inchesRadio.checked = true;
//     }

//     // Hide all tables
//     wrapper.querySelectorAll(".units-table").forEach(table => {
//       table.classList.remove("active");
//     });

//     // Show first Inches table only
//     wrapper.querySelector(".size-inches-unit-js")?.classList.add("active");
//   });
// }

(function () {
  "use strict";

  var WRAPPER_SELECTOR = ".size-chart-modal-wrapper";
  var INCHES_SELECTOR = ".size-inches-unit-js";
  var uid = 0;

  // Fallback for browsers without CSS.escape
  function escapeAttr(value) {
    if (window.CSS && typeof CSS.escape === "function") return CSS.escape(value);
    return String(value).replace(/["\\]/g, "\\$&");
  }

  /**
   * Makes one size-chart instance independent of any other copy in the DOM.
   * Rewrites duplicate id / name / for attributes so the PDP chart and the
   * quick-view chart don't hijack each other's radios.
   */
  function initSizeChartUnits(wrapper) {
    if (!wrapper || wrapper.dataset.unitsInit === "1") return;
    wrapper.dataset.unitsInit = "1";

    var n = ++uid;
    var radios = wrapper.querySelectorAll(".size-units-js input[type='radio']");

    radios.forEach(function (input) {
      if (input.id) {
        // Scope the label lookup to THIS wrapper, not the whole document
        var label = wrapper.querySelector(
          'label[for="' + escapeAttr(input.id) + '"]'
        );
        input.id = input.id + "-sc" + n;
        if (label) label.setAttribute("for", input.id);
      }

      if (input.name) {
        input.name = input.name + "-sc" + n;
      }
    });
  }

  /**
   * Resolves the wrapper for a given radio, with a fallback for modal
   * libraries that relocate content to <body> on open.
   */
  function getWrapper(el) {
    return (
      el.closest(WRAPPER_SELECTOR) ||
      el.closest(
        ".size-guide-modal, .fancybox__content, .mfp-content, [data-size-chart-scope]"
      )
    );
  }

  /**
   * Switches the visible table (Inches / CM) inside one chart.
   */
  function activateUnit(wrapper, targetClass) {
    if (!wrapper || !targetClass) return;

    wrapper.querySelectorAll(".units-table").forEach(function (table) {
      table.classList.remove("active");
    });

    var targetTable = wrapper.querySelector(targetClass);
    if (targetTable) targetTable.classList.add("active");
  }

  /**
   * Resets every chart inside `container` to Inches.
   * Call this with the injected node after a quick view loads.
   */
  function resetSizeChartUnits(container) {
    container = container || document;

    var wrappers = container.querySelectorAll(WRAPPER_SELECTOR);

    // If the container IS a wrapper, include it too
    if (container.matches && container.matches(WRAPPER_SELECTOR)) {
      wrappers = [container].concat(Array.prototype.slice.call(wrappers));
    }

    Array.prototype.forEach.call(wrappers, function (wrapper) {
      initSizeChartUnits(wrapper);

      var inchesRadio = wrapper.querySelector(
        '.size-units-js input[data-class="' + INCHES_SELECTOR + '"]'
      );
      if (!inchesRadio) return;

      inchesRadio.checked = true;
      activateUnit(wrapper, INCHES_SELECTOR);
    });
  }

  // --- Delegated change handler (works for markup added later) -------------
  document.addEventListener("change", function (e) {
    var input = e.target.closest(".size-units-js input[type='radio']");
    if (!input) return;

    var wrapper = getWrapper(input);
    if (!wrapper) return;

    activateUnit(wrapper, input.dataset.class);
  });

  // --- Catch charts injected by quick view / AJAX --------------------------
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches(WRAPPER_SELECTOR)) {
          resetSizeChartUnits(node);
        } else if (node.querySelector && node.querySelector(WRAPPER_SELECTOR)) {
          resetSizeChartUnits(node);
        }
      });
    });
  });

  function start() {
    resetSizeChartUnits(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // Expose for manual calls after your own AJAX
  window.resetSizeChartUnits = resetSizeChartUnits;
})();
// document.addEventListener("change", function (e) {
//   const input = e.target.closest(".size-units-js input[type='radio']");

//   if (!input) return;

//   const wrapper = input.closest(".size-chart-modal-wrapper");

//   if (!wrapper) return;

//   const targetClass = input.dataset.class;

//   if (!targetClass) return;

//   // Only current size chart's tables
//   wrapper.querySelectorAll(".units-table").forEach(function (table) {
//     table.classList.remove("active");
//   });

//   // Get Inches / CM table using data-class
//   const targetTable = wrapper.querySelector(targetClass);

//   if (targetTable) {
//     targetTable.classList.add("active");
//   }
// });


// // Reset every size chart to Inches
// function resetSizeChartUnits(container = document) {
//   container.querySelectorAll(".size-chart-modal-wrapper").forEach(function (wrapper) {

//     const inchesRadio = wrapper.querySelector(
//       '.size-units-js input[data-class=".size-inches-unit-js"]'
//     );

//     if (!inchesRadio) return;

//     inchesRadio.checked = true;

//     wrapper.querySelectorAll(".units-table").forEach(function (table) {
//       table.classList.remove("active");
//     });

//     wrapper
//       .querySelector(".size-inches-unit-js")
//       ?.classList.add("active");
//   });
// }

// Size Guard end

// +more color swatch start 
document.addEventListener("click", function(e){
  if(!e.target.classList.contains("more-colors")) return;
  const wrapper = e.target.closest(".product-color-swatches");
  wrapper.querySelectorAll(".hidden-swatch").forEach(function(item){
      item.classList.remove("hidden-swatch");
  });
  e.target.remove();
});

// +more color swatch end

// slider compare products start 

function initRecommendationSwiper(container) {
  const swiperEl = container.querySelector(".swiper");

  if (!swiperEl || swiperEl.swiper) return;

  new Swiper(swiperEl, {
    observer: true,
    observeParents: true,
    resizeObserver: true,
    watchOverflow: true,

    slidesPerView: 3,
    spaceBetween: 14,

    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      500: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      769: {
        slidesPerView: 3,
        spaceBetween: 14,
      },
    },

    on: {
      init(swiper) {
        swiper.update();
      },
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const recommendation = document.querySelector("product-recommendations");
  if (!recommendation) return;

  const observer = new MutationObserver(() => {
    if (recommendation.querySelector(".swiper-slide")) {
      initRecommendationSwiper(recommendation);
    }
  });

  observer.observe(recommendation, {
    childList: true,
    subtree: true,
  });
});
// slider compare products end

// share popup start
document.addEventListener('click', function(e){

  const btn = e.target.closest('.copy-share-url');

  if(!btn) return;

  const input = document.getElementById(btn.dataset.target);

  navigator.clipboard.writeText(input.value);

  btn.textContent = 'Copied';

  setTimeout(()=>{
    btn.textContent='Copy Link';
  },2000);

});
// share popup end


//product url copy code Section start
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-popup-modal__content-info .copy-code-right").forEach(function (copyBtn) {

    copyBtn.addEventListener("click", function () {

      let link = this.closest(".product-popup-modal__content-info .coupan-right-block").querySelector(".product-popup-modal__content-info .copy-link");

      if (link) {
        let url = link.href;

        navigator.clipboard.writeText(url).then(() => {

          let originalContent = copyBtn.innerHTML;

          // ✅ SVG Tick Icon
          let successSVG = `
            <svg class="tick-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="12" fill="#28a745"/>
              <path d="M7 12L10 15L17 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;

          // Replace button content
          copyBtn.innerHTML = successSVG;

          setTimeout(() => {
            copyBtn.innerHTML = originalContent;
          }, 2000);

        }).catch(err => {
          console.error("Copy failed", err);
        });
      }

    });

  });
});
//product url copy code Section end

// offer 
(function () {
  function initSpecialOffersSlider(scope = document) {
    const sliders = scope.querySelectorAll('.product-special-offers .special-offers-slider');

    sliders.forEach((slider) => {
      // Prevent duplicate initialization
      if (slider.classList.contains('swiper-initialized')) return;

      const wrapper = slider.closest('.special-offers-wrapper');

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 14,
        loop: false,
        navigation: {
          nextEl: wrapper.querySelector('.special-offers-next'),
          prevEl: wrapper.querySelector('.special-offers-prev'),
        },
        breakpoints: {
          750: {
            slidesPerView: 1,
          },
          1025: {
            slidesPerView: 2,
          },
        },
      });
    });
  }

  // Initial Page Load
  document.addEventListener('DOMContentLoaded', function () {
    initSpecialOffersSlider();
  });

  // Quick View Support
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (
          node.matches('.product-special-offers') ||
          node.querySelector('.product-special-offers')
        ) {
          initSpecialOffersSlider(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Copy Coupon Code
  document.addEventListener('click', function (e) {
    const code = e.target.closest('.offer-code');

    if (!code) return;

    const text = code.textContent.trim();

    navigator.clipboard.writeText(text).then(() => {
      const original = code.textContent;

      code.textContent = 'Copied!';

      code.classList.add('copied');

      setTimeout(() => {
        code.textContent = original;
        code.classList.remove('copied');
      }, 2000);
    });
  });
})();

// accoridian 
document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.product__accordion details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', () => {
      if (!accordion.open) return;

      accordions.forEach((item) => {
        if (item !== accordion) {
          item.removeAttribute('open');
        }
      });
    });
  });
});

// 
(function () { function initSlider(slider) { if (slider.dataset.arrowInit) return; slider.dataset.arrowInit = "true"; const parent = slider.parentElement; const prev = document.createElement("button"); prev.className = "lc-scroll-prev"; prev.setAttribute("aria-label", "Previous"); prev.innerHTML = "&#10094;"; const next = document.createElement("button"); next.className = "lc-scroll-next"; next.setAttribute("aria-label", "Next"); next.innerHTML = "&#10095;"; parent.appendChild(prev); parent.appendChild(next); function getScrollAmount() { const card = slider.querySelector(":scope > .lc-single-product"); if (!card) return 300; const cardWidth = card.getBoundingClientRect().width; const styles = window.getComputedStyle(slider); const gap = parseFloat(styles.columnGap || styles.gap) || 0; return cardWidth + gap; } prev.addEventListener("click", () => { slider.scrollBy({ left: -getScrollAmount(), behavior: "smooth" }); }); next.addEventListener("click", () => { slider.scrollBy({ left: getScrollAmount(), behavior: "smooth" }); }); function updateArrows() { prev.style.display = slider.scrollLeft <= 5 ? "none" : ""; next.style.display = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5 ? "none" : ""; } slider.addEventListener("scroll", updateArrows); window.addEventListener("resize", updateArrows); updateArrows(); } function init() { document.querySelectorAll(".lc-product-list").forEach(initSlider); } init(); new MutationObserver(init).observe(document.body, { childList: true, subtree: true }); })();

// Smooth-center the clicked collection category tab within its scroll
// container, on mobile only (desktop tabs don't scroll and are left as-is).
// The tabs (.wizzy-custom-category-tabs / .wizzy-kurta-sub-tabs) are torn
// down and rebuilt from scratch by wizzyCustom2.js on every filter click
// (and applyCategoryFilter() there first clears any previously-selected
// filter before setting the new one, which can produce more than one
// rebuild per click), so the tab that was clicked is remembered here and
// centered once a rebuilt wrapper shows it as active, instead of binding to
// any specific (short-lived) element.
(function () {
  var MOBILE_MEDIA_QUERY = '(max-width: 768px)';
  var PARENT_TABS_SELECTOR = '.wizzy-custom-category-tabs';
  var PARENT_TAB_SELECTOR = '.wizzy-custom-category-tab';
  var SUB_TABS_SELECTOR = '.wizzy-kurta-sub-tabs';
  var SUB_TAB_SELECTOR = '.wizzy-kurta-sub-tab';
  var PENDING_CENTER_MAX_WAIT_MS = 5000;

  function isMobile() {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  // Holds the label of the tab that was actually clicked, until a rebuilt
  // wrapper shows that same tab as active (see applyPendingCenter).
  var pendingCenter = { parent: null, sub: null };
  var pendingCenterSetAt = { parent: 0, sub: 0 };

  // Clicking a tab flags that the tabs (about to be rebuilt by the click's
  // filter change) should be centered once they reappear in the DOM. This
  // does not interfere with the existing click handling in wizzyCustom2.js
  // (active state, filtering, product grid) - it only observes the same
  // click to decide which tab to center afterwards.
  document.addEventListener('click', function (event) {
    if (!isMobile()) return;

    var parentTab = event.target.closest(PARENT_TAB_SELECTOR);
    var subTab = event.target.closest(SUB_TAB_SELECTOR);

    if (parentTab) {
      pendingCenter.parent = parentTab.textContent.trim();
      pendingCenterSetAt.parent = Date.now();
    } else if (subTab) {
      pendingCenter.sub = subTab.textContent.trim();
      pendingCenterSetAt.sub = Date.now();
    }
  }, true);

  // Buttons are focused by the browser on mousedown, before the click event
  // above even fires - and a focused element that isn't fully visible inside
  // a scrollable ancestor gets auto-scrolled to whichever edge is nearest,
  // which is the exact left/right-edge snapping this centers instead of. Only
  // mousedown is used (not pointerdown/touchstart): browsers dispatch it as
  // a synthetic event near touchend purely for genuine taps, never for an
  // in-progress swipe, so an in-progress horizontal swipe that happens to
  // start on top of a tab is never blocked by this.
  document.addEventListener('mousedown', function (event) {
    if (!isMobile()) return;
    if (event.target.closest(PARENT_TAB_SELECTOR) || event.target.closest(SUB_TAB_SELECTOR)) {
      event.preventDefault();
    }
  }, true);

  function centerTab(wrapper, tab) {
    var wrapperRect = wrapper.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();

    // Tab's center, expressed in the wrapper's own scrollable content
    // coordinates (independent of the wrapper's current scroll position).
    var tabCenter = (tabRect.left - wrapperRect.left) + wrapper.scrollLeft + (tabRect.width / 2);
    var target = tabCenter - (wrapper.clientWidth / 2);

    var maxScroll = Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
    target = Math.max(0, Math.min(target, maxScroll));

    if (Math.abs(target - wrapper.scrollLeft) > 1) {
      wrapper.scrollTo({ left: target, behavior: 'smooth' });
    }
  }

  function applyPendingCenter(key, wrapper) {
    if (!isMobile()) return;

    var label = pendingCenter[key];
    if (!label) return;

    // Give up waiting for a matching rebuild after a while, so a click that
    // never resolves (e.g. label mismatch) can't wedge future clicks.
    if (Date.now() - pendingCenterSetAt[key] > PENDING_CENTER_MAX_WAIT_MS) {
      pendingCenter[key] = null;
      return;
    }

    // wizzyCustom2.js can rebuild the tabs more than once per click - e.g.
    // applyCategoryFilter() clears any previously active filter before
    // applying the new one, and separately it calls buildCategoryTabs() from
    // BOTH the VIEW_RENDERED and PRODUCTS_CACHED_RESULTS_RENDERED events,
    // either of which may fire for the same click. Every one of those
    // rebuilds is a brand new element reset to scrollLeft 0, so this stays
    // "pending" (rather than being consumed after the first match) and
    // re-centers on every subsequent rebuild whose active tab matches the
    // clicked label, until it expires or a new click supersedes it. An
    // earlier, non-matching rebuild (e.g. a transient "ALL" state) is
    // ignored and left pending so a later rebuild still gets it.
    var activeTab = wrapper.querySelector('.active');
    if (!activeTab || activeTab.textContent.trim() !== label) return;

    // Wait a frame so layout has settled for the freshly (re)built tabs.
    requestAnimationFrame(function () {
      centerTab(wrapper, activeTab);
    });
  }

  function handleAddedNode(node) {
    if (node.nodeType !== 1) return;

    if (node.matches && node.matches(PARENT_TABS_SELECTOR)) {
      applyPendingCenter('parent', node);
    } else if (node.matches && node.matches(SUB_TABS_SELECTOR)) {
      applyPendingCenter('sub', node);
    }

    if (node.querySelectorAll) {
      node.querySelectorAll(PARENT_TABS_SELECTOR).forEach(function (wrapper) {
        applyPendingCenter('parent', wrapper);
      });
      node.querySelectorAll(SUB_TABS_SELECTOR).forEach(function (wrapper) {
        applyPendingCenter('sub', wrapper);
      });
    }
  }

  // The category tabs are torn down and rebuilt from scratch on every
  // filter change, so watch for the (re)inserted wrapper instead of
  // binding to a specific, short-lived element.
  var tabsObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(handleAddedNode);
    });
  });

  tabsObserver.observe(document.body, { childList: true, subtree: true });
})();

// Mobile menu drawer: for menu items with a submenu, header-drawer.liquid
// renders a real <a class="menu-drawer__menu-item-link"> for the item's own
// text, nested inside the <summary> that also contains the arrow icons.
// A click on that <a> bubbles up to the <summary> by default, which would
// both navigate AND trigger the native <details> disclosure (opened by
// global.js's MenuDrawer.onSummaryClick) - stopping propagation here lets
// the link navigate on its own without also opening the submenu drawer.
// Clicks anywhere else in the row (the arrow icons, or the empty space
// around them) never touch this <a>, so they keep bubbling to the summary
// and continue to open the submenu exactly as before.
document.addEventListener(
  'click',
  function (event) {
    if (event.target.closest('.menu-drawer__menu-item-link')) {
      event.stopPropagation();
    }
  },
  true
);




// Ak custom code

(function () {
  const videos = document.querySelectorAll('video[data-lazy-video]');
  if (!videos.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attach(video) {
    if (video.dataset.loaded) return;
    video.dataset.loaded = 'true';
    video.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    video.load();
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      const video = entry.target;
      if (entry.isIntersecting) {
        attach(video);
        if (!reduceMotion) video.play().catch(function () {});
      } else if (video.dataset.loaded) {
        video.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.1 });

  videos.forEach(function (v) { observer.observe(v); });
})();

//End Ak custom code


// <!-- BUCKS Currency - Body Class Switcher -->
(function () {
  const TARGET_CURRENCY = 'INR';
  const CLASS_NAME = 'csd-inr';

  /**
Helper to add/remove the target class on document.body
   */
  function updateBodyClass(currency) {
    if (!document.body || !currency) return;

    // Handle string or object e.detail gracefully
    const currencyCode = (
      typeof currency === 'string'
        ? currency
        : (currency.currency || currency.code || '')
    ).toString().toUpperCase().trim();

    if (currencyCode === TARGET_CURRENCY) {
      document.body.classList.add(CLASS_NAME);
    } else {
      document.body.classList.remove(CLASS_NAME);
    }
  }

  /**
Initial setup: Store default currency is INR.
Checks saved/geo currency or defaults to INR on page load.
   */
  function init() {
    let initialCurrency = 'INR';
    try {
      const stored = localStorage.getItem('buckscc_customer_currency') ||
                     sessionStorage.getItem('hxoGeoCurrency');
      if (stored) {
        initialCurrency = typeof stored === 'string' && stored.startsWith('{')
          ? JSON.parse(stored).currency || 'INR'
          : stored;
      }
    } catch (e) {
      initialCurrency = 'INR';
    }

    updateBodyClass(initialCurrency);
  }

  // Ensure DOM body is ready before running initial check
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /**
Listen for BUCKS custom currency change event
   */
  document.addEventListener('BUCKS_SELECTED_CURRENCY', function (event) {
    if (event && event.detail) {
      updateBodyClass(event.detail);
    }
  });
})();



////////////////////////////////////////////////////////////////////////////////////////////////////

//Cupan code Section
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".article-card__info_wrapper .copy-code-right").forEach(function (copyBtn) {

    copyBtn.addEventListener("click", function () {

      let link = this.closest(".article-card__info_wrapper .coupan-right-block").querySelector(".article-card__info_wrapper .copy-link");

      if (link) {
        let url = link.href;

        navigator.clipboard.writeText(url).then(() => {

          let originalContent = copyBtn.innerHTML;

          // ✅ SVG Tick Icon
          let successSVG = `
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>
          `;

          // Replace button content
          copyBtn.innerHTML = successSVG;

          setTimeout(() => {
            copyBtn.innerHTML = originalContent;
          }, 2000);

        }).catch(err => {
          console.error("Copy failed", err);
        });
      }

    });

  });
});


// blog FAQ js
document.addEventListener("DOMContentLoaded", function () {

  const accordions = document.querySelectorAll(".this-article-point");

  accordions.forEach(function (section) {

    const content = section.querySelector(".article-point-wrapper");

    // ✅ Open by default
    section.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    const toggle = section.querySelector(".accordion-toggle");

    toggle.addEventListener("click", function () {

      section.classList.toggle("active");

      if (section.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = "0px";
      }

    });

  });

});

// Article FAQ accordion: one item open at a time
(function () {
  function setItemState(item, open) {
    const head = item.querySelector('.acco-head');
    const content = item.querySelector('.acco-content');
    if (!head || !content) return;
    head.classList.toggle('active', open);
    content.classList.toggle('active', open);
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggleItem(head) {
    const item = head.closest('.acc-block-wrap');
    const wrapper = head.closest('.acco-section-wrpper');
    if (!item || !wrapper) return;

    const shouldOpen = !head.classList.contains('active');

    wrapper.querySelectorAll('.acc-block-wrap').forEach(function (other) {
      if (other !== item) setItemState(other, false);
    });

    setItemState(item, shouldOpen);
  }

  document.addEventListener('click', function (event) {
    const head = event.target.closest('.acco-section-wrpper .acco-head');
    if (!head) return;
    event.preventDefault();
    toggleItem(head);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const head = event.target.closest('.acco-section-wrpper .acco-head');
    if (!head) return;
    event.preventDefault();
    toggleItem(head);
  });
})();

// IN THIS STORY js
document.addEventListener('DOMContentLoaded', function () {
  const jumpWrapper = document.querySelector('.jump-wrapper');
  if (!jumpWrapper) return;

  const allWrappers = document.querySelectorAll('.article-content-wrapper');
  let wrapper = null;

  allWrappers.forEach(function (el) {
    if (el.querySelectorAll('h2').length > 0) {
      wrapper = el;
    }
  });

  if (!wrapper) return;

  const headings = wrapper.querySelectorAll('h2');
  const ul = document.createElement('ul');
  const links = [];

  headings.forEach(function (h2, index) {
    if (!h2.id) {
      h2.id = 'jump-heading-' + index;
    }

    const li = document.createElement('li');

    // Index: 01, 02, 03...
    const num = document.createElement('span');
    num.className = 'jump-index';
    num.textContent = String(index + 1).padStart(2, '0');

    const a = document.createElement('a');
    a.href = '#' + h2.id;
    a.textContent = h2.textContent;

    a.addEventListener('click', function (e) {
      e.preventDefault();
      const offset = 100;
      const top = h2.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    li.appendChild(num);
    li.appendChild(a);
    ul.appendChild(li);
    links.push({ li: li, h2: h2 });
  });

  jumpWrapper.appendChild(ul);

  // Active state on scroll
  function setActive() {
    const offset = 140;
    let current = links[0];

    links.forEach(function (item) {
      if (item.h2.getBoundingClientRect().top - offset <= 0) {
        current = item;
      }
    });

    links.forEach(function (item) {
      item.li.classList.toggle('active', item === current);
    });
  }

  setActive();
  window.addEventListener('scroll', setActive, { passive: true });
});

//////////////////////////////////////////////////////////////////////////////////////////////////////